import styled from "styled-components";
import {
  DialogActions,
  DialogTitle,
  FormLabel,
  Stepper,
  TextField,
} from "@mui/material";
import { Button } from "../shared/Button/Button";

export const KitPickupStyledFormLabel = styled(FormLabel)<{
  isError?: boolean;
}>`
  color: ${({ theme, isError }) =>
    isError ? theme.redDark : theme.neutral700} !important;
  font-size: 18px;
  font-family: bold !important;
  text-transform: uppercase;
  margin: 8px 0 0 0;
`;

export const KitPickupStyledFormConfirmationLabel = styled(FormLabel)<{
  isError?: boolean;
}>`
  color: ${({ theme, isError }) =>
    isError ? theme.redDark : theme.neutral700} !important;
  font-size: 18px;
  font-family: bold !important;
  text-transform: uppercase;
  margin: 0 0 0 0;
`;

export const KitPickupStyledDialogTitle = styled(DialogTitle)`
  background-color: ${({ theme }) => theme.neutral50} !important;
  border-bottom: 1px solid ${({ theme }) => theme.neutral100} !important;
  height: 72px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 25px;

  .MuiTypography-root {
    color: ${({ theme }) => theme.redMedium};
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 32px;
    letter-spacing: 1.2px;
  }
`;

export const KitPickupErrorMessage = styled.div<{ $isError: boolean }>`
  background: ${({ theme, $isError }) =>
    $isError ? theme.redPastel : theme.blueSubtle};
  border-left: 3px solid
    ${({ theme, $isError }) => ($isError ? theme.redDark : theme.blueDark)};
  padding: 12px 20px;
  border-radius: 6px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  white-space: pre-wrap;
  svg {
    margin-right: 10px;
  }
`;

export const KitPickupStyledDialogActions = styled(DialogActions)`
  background-color: ${({ theme }) => theme.neutral50} !important;
  border-top: 1px solid ${({ theme }) => theme.neutral100} !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;

  > * {
    &:nth-child(1) {
      margin: 10px auto 10px 10px;
    }

    &:nth-child(2) {
      flex: 1;
      display: flex;
      justify-content: center;
    }

    &:nth-child(3) {
      margin: 10px 16px 10px auto;
    }
  }
`;

export const KitPickupTextField = styled(TextField)(({ theme }) => ({
  "& .MuiFormHelperText-root": {
    color: theme.redMedium,
  },
}));

export const StepperWrapper = styled(Stepper)`
  max-width: 250px;
  width: 100%;
  .MuiStep-root {
    padding-right: 0px !important;
  }
`;

export const KitPickupBackButton = styled(Button)`
  && {
    background-color: ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.redMedium};
    border: 1px solid ${({ theme }) => theme.redMedium};

    &:hover {
      background-color: ${({ theme }) => theme.white};
      opacity: 0.8;
    }
  }
`;

export const KitPickupHelper = styled.div`
  color: ${({ theme }) => theme.blueDark};
  font-family: light;
  line-height: inherit;
  font-size: 12px;
  svg {
    width: 15px;
    margin-bottom: -8px;
    margin-right: 3px;
  }
`;
